export const ICON_PROPS = {
  size: 24,
  className: 'mb-2',
};
